import { TextField, TextFieldProps } from '@mui/material';

interface ITextFieldWrapperProps {
    blockEnterKey?: boolean;
}

const TextFieldWrapper = ({ blockEnterKey = true, onKeyDown, ...props }: TextFieldProps & ITextFieldWrapperProps) => {
    const onKeyDownHandler = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (blockEnterKey && event.key.toLowerCase() === 'enter') event.preventDefault();
        onKeyDown?.(event);
    };

    return <TextField {...props} onKeyDown={onKeyDownHandler} />;
};

export default TextFieldWrapper;
